import type {
  AddGiftLinksBody,
  AddGiftLinksResult,
  GiftLinkAdditionsQuote,
  QuoteGiftLinksBody,
} from "@/interfaces/giftLinks";
import { apiClient } from "@/lib/apiClient";

/** POST /campaigns/:campaignId/gift-links/additions/quote. Prices `body.count` new gift links (free spaces first, then paid); `body.depositMode` is the postpaid choice when the wallet is short. */
export async function quoteGiftLinkAdditions(
  campaignId: string,
  body: QuoteGiftLinksBody,
  campaignPath = `/campaigns/${campaignId}`,
): Promise<GiftLinkAdditionsQuote> {
  const { data } = await apiClient.post<{ success: true; data: GiftLinkAdditionsQuote }>(
    `${campaignPath}/gift-links/additions/quote`,
    body,
  );
  return data.data;
}

/** POST /campaigns/:campaignId/gift-links/additions. Adds gift links; `body.expected` echoes the quote being confirmed. */
export async function addGiftLinks(
  campaignId: string,
  body: AddGiftLinksBody,
  campaignPath = `/campaigns/${campaignId}`,
): Promise<AddGiftLinksResult> {
  const { data } = await apiClient.post<{ success: true; data: AddGiftLinksResult }>(
    `${campaignPath}/gift-links/additions`,
    body,
  );
  return data.data;
}
